import { Navigate, useRoutes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// import DashboardLayout from '../layout/dashboard';

const PageOne = lazy(() => import('../pages/PageOne'));
const Pricing = lazy(() => import('../pages/Pricing'));
const UserDataDeletion = lazy(() => import('../pages/UserDataDeletion'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
export default function Router() {
  return useRoutes([
    ...allRoutes,
  ]);
}


const allRoutes = [
    {
      path: '',
      element: (
        <Suspense >                  
        <Outlet />
        </Suspense>
      ),
      children: [
        { path: '', element: <PageOne /> },
        { path: 'pricing', element: <Pricing /> },
        { path: 'UserDataDeletion', element: <UserDataDeletion/> },
        { path: 'privacy-policy', element: <PrivacyPolicy /> },        
      ], 

    },
  ];